import Vue from 'vue'
import Router from 'vue-router'

import Dashboard from '@/components/Dashboard'
import Login from '@/components/Login'
import DataEditor from './components/editor/DataEditor'

Vue.use(Router)

export const router = new Router({
  routes: [
    {
      path: '/',
      component: Dashboard,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/dataEditor/:schemaId',
      name: 'dataEditor',
      component: DataEditor
    },
    {path: '/login', component: Login},
    // otherwise redirect to home
    {path: '*', redirect: '/'}
  ]
})

router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const authRequired = to.matched.some(record => record.meta.requiresAuth)
  console.log('in router before Each')
  const user = JSON.parse(localStorage.getItem('user'))
  const loggedIn = user

  if (authRequired && !loggedIn) {
    return next('/login')
  }

  next()
})



// WEBPACK FOOTER //
// ./src/router.js